import React, { ReactNode } from 'react';
import classnames from 'classnames';

const BannerGradient = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => (
  <div className={classnames('banner banner--gradient', className)}>
    <div className="container">{children}</div>
  </div>
);

export default BannerGradient;
